(function () {
var $014ca3ecc4b2a62b$var$cf7Config = window.juniperContactForm || {};
var $014ca3ecc4b2a62b$var$TOPICS_REQUIRING_PRODUCT = $014ca3ecc4b2a62b$var$cf7Config.topicsRequiringProduct || [];
function $014ca3ecc4b2a62b$var$initTopicProductConditional(form) {
    var topicSelect = form.querySelector('[name="topic"]');
    var productWrap = form.querySelector('.wpcf7-form-control-wrap[data-name="product"]');
    if (!topicSelect || !productWrap) return;
    var productField = productWrap.closest('label') || productWrap;
    var productSelect = productWrap.querySelector('select[name="product"]');
    function sync() {
        var shouldShow = $014ca3ecc4b2a62b$var$TOPICS_REQUIRING_PRODUCT.includes(topicSelect.value);
        productField.hidden = !shouldShow;
        if (!productSelect) return;
        productSelect.toggleAttribute('required', shouldShow);
        productSelect.setAttribute('aria-required', String(shouldShow));
        if (!shouldShow && productSelect.value) {
            productSelect.value = '';
            productSelect.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
    }
    topicSelect.addEventListener('change', sync);
    form.addEventListener('reset', function() {
        setTimeout(sync, 0);
    });
    sync();
}
function $014ca3ecc4b2a62b$var$initContactFormConditionals() {
    document.querySelectorAll('.wpcf7 form').forEach($014ca3ecc4b2a62b$var$initTopicProductConditional);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $014ca3ecc4b2a62b$var$initContactFormConditionals);
else $014ca3ecc4b2a62b$var$initContactFormConditionals();

})();
//# sourceMappingURL=contact-form-conditional.js.map
